"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(id, list, debit) {
  var result = false;

  if (debit && id && (list === null || list === void 0 ? void 0 : list.length)) {
    var card = list.find(function (item) {
      return item.id === id;
    });
    result = card ? typeof card.get === 'function' ? card.get('isForeign') : card.isForeign : false;
  }

  return result;
}